// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a3rp","placeholdersHeader":"styles_placeholdersHeader__1xfDd","editorStyle":"styles_editorStyle__sMdki","placeholdersBox":"styles_placeholdersBox__1pk_R"};